import { render, staticRenderFns } from "./onoffice.vue?vue&type=template&id=9d0cbe16&"
import script from "./onoffice.vue?vue&type=script&lang=js&"
export * from "./onoffice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports